// extracted by mini-css-extract-plugin
module.exports = {"container":"Form_container__Uu66t","heading":"Form_heading__20Gjg","form":"Form_form__1ipwi"};